import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';

const RenderTextFieldReduxMin = ({  input, label, name, type, withFocus, meta: { touched, error }}) => {
    return (
        <div>
        <TextField
            {...input}
            type={!type ? "text" : type}
            fullWidth
            InputLabelProps= {
              {
                // style: { color: '#000000'}
              }
            }
            label={label}
            autoComplete ='off'
        />
        {touched && error && <span style = {{ color: 'red'}}>{error}</span>}
        </div>
    );
};

RenderTextFieldReduxMin.propTypes = {
    label: PropTypes.string.isRequired,
};

export default RenderTextFieldReduxMin;